import React from 'react';
import { Grid } from '@material-ui/core';
import { Button } from '@one-thd/sui-atomic-components';
import { Carousel } from '@thd-olt-component-react/core-ui';
import { fallbackImage, isNewPerk } from '../../shared/commons';
import { buttonText, summaryDescription } from '../../../../constants';
import { SmallAlert } from '../../shared/components/SmallAlert/SmallAlert';
import { setOverlayEvent } from '../../../../utils/analytics';
import { useDisplayAmount } from '../../../../utils/PerkOptionsUtil';
export var HasPerksSummaryDesktop = function (_a) {
    var setOpenPerksDetailModal = _a.setOpenPerksDetailModal, setCurrentPerkDetails = _a.setCurrentPerkDetails, perksList = _a.perksList;
    var getDisplayAmount = useDisplayAmount();
    var slides = perksList.map(function (perk, index) {
        var openModal = function () {
            setOpenPerksDetailModal(true);
            setCurrentPerkDetails(perk);
            setOverlayEvent("perk details: redeem: ".concat(perk.perkTitle.toLowerCase()));
        };
        var alertMessage = "".concat(perk.daysLeft, " day").concat(perk.daysLeft < 2 ? '' : 's', " left to use Perk");
        return (React.createElement(Grid, { key: "card-".concat(index), container: true, className: "AvailablePerks__Card sui-flex sui-flex-row sui-justify-evenly sui-align-center" },
            React.createElement(Grid, { item: true, xs: 1 }),
            React.createElement(Grid, { item: true, xs: 4, className: "AvailablePerks__CardImgPadding sui-flex sui-flex-col sui-justify-start sui-align-center" },
                React.createElement("img", { src: perk.perkImageUrl, alt: "perk-img", className: "PerkHistoryLogo", height: "86px", width: "86px", onError: fallbackImage })),
            React.createElement(Grid, { item: true, xs: 6, className: "sui-pl-2 sui-flex sui-flex-col sui-justify-start sui-align-center" },
                React.createElement(Grid, { className: "AvailablePerks__CardNew" }, isNewPerk(perk.activationTime, perk === null || perk === void 0 ? void 0 : perk.isManuallyFirst) && (React.createElement("div", { className: "AvailablePerks__CardNewIcon sui-flex sui-flex-row sui-justify-center sui-align-center" },
                    React.createElement("p", null, "NEW")))),
                React.createElement(Grid, { className: "AvailablePerks__CardHeader sui-mb-2" },
                    React.createElement("div", null,
                        React.createElement("div", { className: "AvailablePerks__CardAmount" }, getDisplayAmount(perk)),
                        React.createElement("div", { className: "AvailablePerks__CardTitle" }, perk.perkTitle))),
                React.createElement(Grid, { className: "sui-text-md sui-flex sui-flex-col sui-justify-between sui-align-start sui-my-4" }, perk.expirationTime && React.createElement("div", null,
                    "Expires - ",
                    perk.expirationTime)),
                React.createElement(Grid, { className: "AvailablePerks__CardButton" },
                    React.createElement(Button, { variant: "primary", onClick: openModal }, buttonText.viewDetails)),
                React.createElement(Grid, { className: "AvailablePerks__CardExpiring sui-mt-2" }, perk.daysLeft < 14 &&
                    sessionStorage.getItem('perkClaimed') !== 'true' && (React.createElement("div", { className: "AvailablePerks__CardExpiringAlert" },
                    React.createElement(SmallAlert, { alertMessage: alertMessage, isMultiLine: false }))))),
            React.createElement(Grid, { item: true, xs: 1 })));
    });
    return (React.createElement("div", null,
        React.createElement("div", { className: "AvailablePerks__Summary" }, summaryDescription),
        React.createElement(Carousel, { fade: true, navigation: true, dotsBelow: true, peek: false, slidesPerView: "auto", slidesPerGroup: 1, breakpoints: {
                sm: {
                    slidesPerView: 2,
                    slidesPerGroup: 1,
                },
                md: {
                    slidesPerView: 3,
                    slidesPerGroup: 1,
                },
                lg: {
                    slidesPerView: 3,
                    slidesPerGroup: 1,
                },
                xl: {
                    slidesPerView: 3,
                    slidesPerGroup: 1,
                },
            } }, slides)));
};
